import React from 'react';

import { IDialogProps } from '@/context/DialogContext/DialogContext';
import CommentDialog from './CommentDialog';

const AdminCommentDialog = (props: IDialogProps) => {
  const { initialRecord } = props;

  return (
    <CommentDialog
      {...props}
      pickerApiPathParams={{
        tenant_id: initialRecord?.tenant_id,
      }}
      alternativeSubmodelAPIPath={{
        Dodijeljeno: 'system/tenants/{tenant_id}/users?view=picker',
      }}
    />
  );
};

export default AdminCommentDialog;
